import { ComponentType } from "react";

/**
 *
 * @param fn function
 * @param retriesLeft 重载次数
 * @param interval 间隔
 */
export function retry(fn, retriesLeft = 5, interval = 1000) {
  return new Promise<{default: ComponentType<any>}>((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            reject(error);
            return;
          }

          // Passing on "reject" is the important part
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
}


/** 解决微信浏览器键盘收起页面不回弹 */
export function focusFn () {
  function isWeiXinAndIos() {
    let ua = '' + window.navigator.userAgent.toLowerCase()
    let isWeixin = /MicroMessenger/i.test(ua)
    let isIos = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua)
    return isWeixin && isIos
  }
  let myFunction
  let isWXAndIos = isWeiXinAndIos()
  if (isWXAndIos) {
    document.body.addEventListener('focusin', () => {
      clearTimeout(myFunction)
    })
    document.body.addEventListener('focusout', () => {
      clearTimeout(myFunction)
      myFunction = setTimeout(function () {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      }, 200)
    })
  }
}
